<div class="d-flex flex-column overflow-hidden h-100">

  @if (userIsAuthenticated) {
  <adf-global-application-toolbar class="flex-shrink-0">
  </adf-global-application-toolbar>

  <main class="d-flex flex-row flex-grow-1" style="min-height: 0;">
    <div class="d-flex flex-shrink-0">
      <adf-sidebar-new class="h-100"></adf-sidebar-new>
    </div>
    <div class="d-flex flex-column flex-grow-1 p-4 overflow-auto" style="min-height: 0;">
      <router-outlet></router-outlet>
    </div>
  </main>
  }
  @else{
  <div class="p-4">

    @if(isOnline){
      {{'AUTHENTICATION.WAITING_FOR_AUTHENTICATION' | translate}}
    }
    @else{
      {{'AUTHENTICATION.DESKTOP_USER_NOT_EXIST' | translate}}
    }
  </div>
  }

</div>
<adf-toast aria-live="polite" aria-atomic="true" />